/** @jsxImportSource @emotion/react */
import { ReactComponent as LeftArrow } from "assets/Mobile/icons/arrowLeft.svg";
import { useNavigate } from "react-router-dom";

import { HeaderCustomStyle } from "./index.style";

type Props = {
  title: string;
};

function HeaderCustom({ title }: Props) {
  const navigate = useNavigate();
  return (
    <div css={HeaderCustomStyle.container}>
      <span onClick={() => navigate(-1)} className="icon-back">
        <LeftArrow />
      </span>
      <span className="title">{title}</span>
    </div>
  );
}

export default HeaderCustom;
